import { DOCUMENT, Inject, Injectable } from "@angular/core";
import { Settings } from "../utils/settings";
// import { LocalStorageService } from './localstorage';
export type Theme =
  | null
  | "light"
  | "dark"
  | "bumblebee"
  | "emerald"
  | "corporate"
  | "retro"
  | "cyberpunk"
  | "valentine"
  | "halloween"
  | "garden"
  | "forest"
  | "aqua"
  | "lofi"
  | "pastel"
  | "fantasy"
  | "wireframe"
  | "black"
  | "luxury"
  | "dracula";

@Injectable({
  providedIn: "root",
})
export class ThemeService {
  private readonly theme: Theme = null;
  private readonly themeDefault: Theme = "light";

  constructor(
    @Inject(DOCUMENT) private document: Document,
    // private localStorageService: LocalStorageService
  ) {}

  async initTheme() {
    const theme: string | null = await Settings.get<any>("theme");
    if (!theme) {
      // this.localStorageService.set('theme', this.themeDefault);
      await Settings.set("theme", this.themeDefault!);
    }

    // if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
    //   this.localStorageService.set('theme', 'dark');
    // }

    // if (window.matchMedia('(prefers-color-scheme: light)').matches) {
    //   this.localStorageService.set('theme', 'light');
    // }

    this.document.documentElement.setAttribute(
      "data-theme",
      (await Settings.get<any>("theme"))!,
    );
  }

  async switchTheme() {
    const theme: string | null = await Settings.get<any>("theme");
    console.log("theme: ", theme);
    // if(!!theme) {
    //   await Settings.set('theme', theme === 'light' ? 'dark' : 'light');
    // }
  }
}
